import { readOnly } from "models/restutil";

export class EnvironmentalConditionDto {
  public static ApiUrl = 'api/environmental-conditions';

  Id: number;
  GlobalAnalysisId?: number;
  Hs?: number
  Tp?: number;
  Vc?: number;
  SortIndex?: number;
  Created?: Date
  Updated?: Date;
  Deleted?: Date;
  @readOnly()
  IsDeleted: boolean;
}
